import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Form, Input, Button, notification } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { withLocale } from '../../l10n';
import service from '../../services/Service';
import LogoKiconex from '../../assets/img/png/logo.png';
import '../SignIn/SignIn.scss';
import '../../components/LoginForm/LoginForm.scss';

function ForgotPassword(props) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    if (!email) {
      notification['error']({
        message: props.lang.handle('Introduzca su correo electrónico'),
      });
      return;
    }

    setLoading(true);
    const res = await service.post('password-reset/request', { email });
    setLoading(false);

    if (res && res.data && res.data.ok) {
      notification['success']({
        message: props.lang.handle(
          'Si el correo existe, recibirá un mensaje con instrucciones para restablecer su contraseña.'
        ),
        duration: 6
      });
      navigate('/login');
    }
  };

  return (
    <div className="signInForm">
      <img className="login-logo" src={LogoKiconex} alt="Kiconex" />
      <Form className="login-form" onFinish={onSubmit}>
        <Form.Item>
          <Input
            prefix={<MailOutlined className="site-form-item-icon" />}
            name="email"
            type="email"
            placeholder={props.lang.handle('Correo electrónico')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className="login-form-button"
          >
            {props.lang.handle('Enviar enlace de recuperación')}
          </Button>
        </Form.Item>

        <Form.Item style={{ textAlign: 'center', marginBottom: 0 }}>
          <Link to="/login">
            {props.lang.handle('Volver al inicio de sesión')}
          </Link>
        </Form.Item>
      </Form>
    </div>
  );
}

export default withLocale(ForgotPassword);
